'use client';

import { forwardRef } from 'react';
import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

export type TextFieldProps = MuiTextFieldProps;

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  return <MuiTextField ref={ref} {...props} />;
});

TextField.displayName = 'TextField';
